module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"joy-of-music\"-in-garden-grove-california-a3747acbd64c76084953925d7a6a5f38.png";